import { makeStyles } from 'tss-react/mui'

// TODO jss-to-tss-react codemod: '@global' is not supported by tss-react.
// See https://mui.com/material-ui/customization/how-to-customize/#4-global-css-override for alternatives.
const useStyles = makeStyles()(() => ({
  '@global': {
    '.BeaconFabButtonFrame': {
      display: 'none !important',
    },
  },
}))

/** Give space between the end of content for a bottom AppBar. Also moves the
 * HelpScout beacon. */
const BeaconHider: React.FC<React.PropsWithChildren> = () => {
  useStyles()

  return null
}

export default BeaconHider
